export const NumberComparer = (x, y) => x - y;
